module.exports = __webpack_public_path__ + "img/ua.6d944bf7.svg";